import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { cn } from "$lib/utils.js";

var root = $.from_html(`<div><!></div>`);

export default function Card_title($$anchor, $$props) {
	$.push($$props, true);

	let ref = $.prop($$props, 'ref', 15, null),
		restProps = $.rest_props($$props, [
			'$$slots',
			'$$events',
			'$$legacy',
			'ref',
			'class',
			'children'
		]);

	var div = root();

	$.attribute_effect(div, ($0) => ({ 'data-slot': 'card-title', class: $0, ...restProps }), [() => cn("leading-none font-semibold", $$props.class)]);

	var node = $.child(div);

	$.snippet(node, () => $$props.children ?? $.noop);
	$.reset(div);
	$.bind_this(div, ($$value) => ref($$value), () => ref());
	$.append($$anchor, div);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiY2FyZC10aXRsZS5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cblx0aW1wb3J0IHR5cGUgeyBIVE1MQXR0cmlidXRlcyB9IGZyb20gXCJzdmVsdGUvZWxlbWVudHNcIjtcblx0aW1wb3J0IHsgY24sIHR5cGUgV2l0aEVsZW1lbnRSZWYgfSBmcm9tIFwiJGxpYi91dGlscy5qc1wiO1xuXG5cdGxldCB7XG5cdFx0cmVmID0gJGJpbmRhYmxlKG51bGwpLFxuXHRcdGNsYXNzOiBjbGFzc05hbWUsXG5cdFx0Y2hpbGRyZW4sXG5cdFx0Li4ucmVzdFByb3BzXG5cdH06IFdpdGhFbGVtZW50UmVmPEhUTUxBdHRyaWJ1dGVzPEhUTUxEaXZFbGVtZW50Pj4gPSAkcHJvcHMoKTtcbjwvc2NyaXB0PlxuXG48ZGl2XG5cdGJpbmQ6dGhpcz17cmVmfVxuXHRkYXRhLXNsb3Q9XCJjYXJkLXRpdGxlXCJcblx0Y2xhc3M9e2NuKFwibGVhZGluZy1ub25lIGZvbnQtc2VtaWJvbGRcIiwgY2xhc3NOYW1lKX1cblx0ey4uLnJlc3RQcm9wc31cbj5cblx0e0ByZW5kZXIgY2hpbGRyZW4/LigpfVxuPC9kaXY+XG4iXSwibWFwcGluZ3MiOiI7O1NBRVUsRUFBRSxRQUE2QixlQUFlOzs7O3NEQUZ4RCxDQUFDOzs7S0FLQyxHQUFHLDhCQUFhLElBQUk7RUFHakIsU0FBUzs7Ozs7Ozs7Ozs7NkVBUVQsU0FBUyxZQUROLEVBQUUsQ0FBQyw0QkFBNEI7Ozs7OzsrQkFGM0IsR0FBRyxpQkFBSCxHQUFHOzs7QUFIaEIsQ0FBQyJ9